import React, { useRef, useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from "react-router-dom";
import '../components/css/ProjectGallery.css'
import AppFilterImageGallery from "../../../interface/filter_image_gallery/AppFilterImageGallery"

import ImageData from "./RumahImageData";
import { Helmet } from 'react-helmet';
import RumahFilter from './rumah_filter/RumahFilter';
import SEO from '../../../SEO/SEO';

function Rumah() {

    /** navigation to from div clicked */
    const navigate = useNavigate();
    /** onClick={() => { navigate('/detail-project/fawn-house') }} */

    return (
        <div className="gallery-house fade">

            <SEO
                title="Proyek Rekanata Konstruksi - Jasa Kontraktor Bangunan Profesional di Bandung & Seluruh Indonesia"
                canonical="https://rekanata.com/house-project"
            // Contoh penimpaan (uncomment dan sesuaikan jika ingin spesifik untuk Home):
            // ogImage="https://rekanata.com/images/home-hero-og.jpg"
            // twitterImage="https://rekanata.com/images/home-hero-twitter.jpg"
            // metaKeywords="kontraktor rumah bandung, renovasi kantor jakarta, desain interior modern"
            />

            <div className="gallery-house-hero-image">
                <div className="gallery-house-hero-text">
                    <h1 className='gallery-house-h1'>PROYEK RUMAH</h1>
                </div>
            </div>

            {/** <AppFilterImageGallery/> */}
            {/** Include filter project gallery */}
            <RumahFilter />

            <div className="row-house">

                {/** RUMAH */}
                {/** DISABLE CONTENT (di arsipkan)
                <div className="column-house">
                    <div className="project-header" id="id-project-rumah">
                        <div className="project-container">
                            {ImageData.map((content) => (
                                <img src={content.AWILIGAR_HOUSE} alt="Thumb" className="image" />
                            ))}

                            <div className="project-overlay">
                                <div className='content-title'>
                                    <p id='myUL'>Awiligar House</p>
                                </div>

                                <div className='content-year'>
                                    <p>2022</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                */}

            </div>
        </div>
    )
}

export default Rumah